export const patientComplianceAnalyticAction = {
  changeFilter: (state, action) => {
    const { type, value } = action.payload;
    state[type] = value;
  },
};
